import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import thalesLogo from '../../assets/logo/thales.png';
import damenLogo from '../../assets/logo/damen.png';
import navalLogo from '../../assets/logo/naval.png';

const LandingPartnersComponent = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)'); 

    return (
        <Box sx={{ backgroundColor: '#fff' }}>
            <Grid container sx={{ textAlign: 'center', position: 'relative' }}>
                <Grid item xs={12} sm={12}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 60, textAlign: 'center', color: '#08244d', mt: 2, mb: 2 }}>
                        Partners
                    </Typography >
                </Grid>
                <Grid item xs={12} sm={4} sx={{marginTop: 5, mb: isSmallScreen ? 1 : 20, alignSelf: 'center'}}>
                    <img src={thalesLogo} style={{objectFit: 'cover', width:  isSmallScreen ? 250 : 320}} />
                </Grid>
                <Grid item xs={12} sm={4} sx={{marginTop: 5, mb: isSmallScreen ? 1 : 20, alignSelf: 'center'}}>
                    <img src={damenLogo} style={{objectFit: 'cover', width: isSmallScreen ? 250 : 320}} />
                </Grid>
                <Grid item xs={12} sm={4} sx={{marginTop: 6, mb: isSmallScreen ? 1 : 20, alignSelf: 'center'}}>
                    <img src={navalLogo} style={{objectFit: 'cover', width: isSmallScreen ? 250 : 320}} />
                </Grid>
            </Grid>
        </Box>
    );
}

export default LandingPartnersComponent;
